import { render, staticRenderFns } from "./FirstCuadro.vue?vue&type=template&id=628608f8&"
import script from "./FirstCuadro.vue?vue&type=script&lang=js&"
export * from "./FirstCuadro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports